import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const apiKeysSlice = createSlice({
  name: 'apiKeys',
  initialState: {
    keys: []
  },
  reducers: {
    setKeys: (state, { payload }) => {
      state.keys = payload;
    }
  }
});

export const { setKeys } = apiKeysSlice.actions;

export const getKeys = userId => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/apikey/by-user/${userId}`
    );
    dispatch(setKeys(data));
  } catch (error) {
    console.log(error);
  }
};

export const createKey = (userId, name, webHook, time) => async () => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_SERVER}/apikey/${userId}`,
      data: { name, time, webHook }
    });
    return response;
  } catch (error) {
    return { status: 400, message: error.response?.data?.message };
  }
};

export const deleteKey = keyId => async () => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/apikey/logical/${keyId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const changeStatusKey = keyId => async () => {
  try {
    const response = await axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_SERVER}/apikey/${keyId}`
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export default apiKeysSlice.reducer;
